<template>
  <div class="ExpenseLedger">
    <div>
      <div class="flex">
        <div class="lt-area flex-auto">
          <div class="inline">
            <div class="inline bold">기간</div>
            <APeriodSelector
              ref="period"
              class="inline ml-default"
              :value="search_period"
              :disabled="disabled"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              :disabled="disabled || selection.length < 1"
              @click="handleClickListPrint"
              >리스트 인쇄</el-button
            >
          </div>
          <div class="inline ml-default">
            <el-checkbox v-model="sum_flag">소계 표기</el-checkbox>
          </div>
        </div>
        <div class="rt-area flex-fixed align-right">
          <el-button
            icon="fas fa-file-excel fa-lg"
            style="padding: 8px;"
            circle
            @click="handleClickExcel"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="mt-default">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input
            class="right c-danger"
            :value="util.addComma(pay_price)"
            readonly
          >
            <template slot="prepend">결제합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            class="right c-danger"
            :value="util.addComma(discount_price)"
            readonly
          >
            <template slot="prepend">DC합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input class="right" :value="util.addComma(income_price)" readonly>
            <template slot="prepend">매입합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            class="right c-primary"
            :value="util.addComma(tax_price)"
            readonly
          >
            <template slot="prepend">세액합계</template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <ATable
      ref="table"
      v-loading="loading"
      :height="600"
      :data="items"
      :disabled="disabled"
      :rowClassName="handleRowClassName"
      hide-top-panel
      hide-pagination
      hide-button-insert
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        label="선택"
        align="center"
        :width="$width.selection"
        :selectable="selectable"
      />
      <el-table-column
        prop="deal_date"
        label="입고일"
        :width="$width.date"
        show-overflow-tooltip
      />
      <el-table-column
        prop="order_code"
        label="발주번호"
        width="100"
        class-name="order_code"
        show-overflow-tooltip
      />
      <el-table-column
        prop="product_name"
        label="품목"
        width="200"
        class-name="product_name"
        show-overflow-tooltip
      />
      <el-table-column
        prop="size"
        :label="$t('lang.size')"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="amount"
        label="수량"
        class-name="cell-number"
        :width="$width.amount"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="unit_name"
        label="단위"
        class-name="unit_name"
        :width="$width.unit_name"
      />
      <el-table-column
        prop="cost"
        label="단가"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="supply_price"
        label="공급가액"
        class-name="cell-number supply_price"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="tax"
        label="세액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="price"
        label="금액"
        class-name="cell-number price"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="balance"
        label="미결금"
        class-name="cell-number balance"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column prop="desc" label="비고" show-overflow-tooltip />
      <el-table-column
        prop="created_user_name"
        label="등록자"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        label="수정자"
        :width="$width.username"
      />
    </ATable>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="거래내역 리스트"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <ExpensePrint
        v-if="dialog_visible"
        :period="period"
        :customer="customer"
        :data="selectedData"
        :sum_flag="sum_flag"
        @completed="handleCompletedListPrint"
      />
    </el-dialog>
  </div>
</template>
<script>
import { account_form } from "@/common/mixins/account_form";
import ExpensePrint from "./ExpensePrint";

export default {
  name: "ExpenseLedger",
  mixins: [account_form],
  components: { ExpensePrint },
  data() {
    return {
      title: this.$t("title.sale_ledger"),
      search_period: { value: "1w" },
      period: {},
      loading: false,
      last_item: null,
      items: [],
      items_original: [],
      pay_price: 0,
      discount_price: 0,
      income_price: 0,
      tax_price: 0,
      selection: [],
      selectedData: [],
      dialog_visible: false,
      sum_flag: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer: function() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (!this.customer) {
        return;
      }
      this.loading = true;
      this.pay_price = 0;
      this.discount_price = 0;
      this.income_price = 0;
      this.tax_price = 0;
      this.api
        .selectExpenseCustomerDate(this.customer.id, this.period.startDate)
        .then((res) => {
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, this.title, res);
          }
          this.last_item = res.data;
          this.api
            .listExpenseCustomer(this.customer.id, this.period)
            .then((res) => {
              this.loading = false;
              if (res.error !== this.system.noError) {
                this.util.notify_response_error(this, this.title, res);
                return;
              }
              this.items_original = res.data;
              this.organizeData();
            });
        });
    },
    /**
     * 데이터에 소계등을 추가한다.
     */
    organizeData() {
      let items = Object.assign([], this.items_original);
      let pay_price = 0;
      let discount_price = 0;
      let income_price = 0;
      let tax_price = 0;
      let balance = this.last_item ? this.last_item.balance : 0;
      items.forEach((item) => {
        if (item.balance !== null) {
          balance = item.balance;
        } else {
          item.balance = balance;
        }
        if (item.type_flag === "2") {
          item.product_name = "결제액";
          if (item.pay_way_flag == "2") {
            item.size = this.getBankAccountName(item.account_id);
          } else {
            item.size = this.system.options.resolve_pay_way_flag(
              item.pay_way_flag
            );
          }
          if (item.discount_price > 0) {
            item.unit_name = "DC";
            item.cost = item.discount_price;
          }
          item.price = item.pay_price;
          pay_price += item.price;
          discount_price += item.discount_price;
        } else {
          income_price += item.price;
          tax_price += item.tax;
        }
      });
      // 월별 소계 추가
      let month_old = "";
      let month_cur = "";
      let month_supply_price = 0;
      let month_tax = 0;
      let month_price = 0;
      let month_amount = 0;
      // 기간누계 추가
      let total_supply_price = 0;
      let total_tax = 0;
      let total_price = 0;
      let total_amount = 0;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        month_cur = item.deal_date.substring(0, 7);
        if (month_old !== month_cur) {
          if (month_old !== "") {
            items.splice(i, 0, {
              sum_row: true,
              product_name: "소 계",
              amount: month_amount,
              supply_price: month_supply_price,
              tax: month_tax,
              price: month_price,
            });
            month_supply_price = 0;
            month_tax = 0;
            month_price = 0;
            month_amount = 0;
            i++;
          }
          month_old = month_cur;
        }
        if (item.type_flag === "1") {
          month_supply_price += item.supply_price;
          month_tax += item.tax;
          month_price += item.price;
          month_amount += item.amount;
          total_supply_price += item.supply_price;
          total_tax += item.tax;
          total_price += item.price;
          total_amount += item.amount;
        }
      }
      if (items.length > 0 && !items[items.length - 1].sum_row) {
        //마지막 행이 소계가 아니라면
        items.splice(items.length + 1, 0, {
          sum_row: true,
          product_name: "소 계",
          amount: month_amount,
          supply_price: month_supply_price,
          tax: month_tax,
          price: month_price,
        });
      }
      // 기간누계 추가
      items.splice(items.length + 2, 0, {
        sum_row: true,
        total_sum: true,
        product_name: "기간 누계",
        amount: total_amount,
        supply_price: total_supply_price,
        tax: total_tax,
        price: total_price,
      });
      //상단에 전기미결금 추가
      let last = { id: -1, product_name: "전 기 미 결 금", type_flag: "3" };
      last.balance = this.last_item ? this.last_item.balance : 0;
      items.splice(0, 0, last);

      this.pay_price = pay_price;
      this.discount_price = discount_price;
      this.income_price = income_price;
      this.tax_price = tax_price;
      this.items = items;
    },
    selectable(row) {
      return !!row.type_flag;
    },
    handleChangePeriod(period) {
      this.period = period;
      this.loadData();
    },
    handleRowClassName({ row }) {
      if (row.type_flag === "2") {
        return "pay-row";
      } else if (row.total_sum) {
        return "warning-row";
      } else if (row.sum_row) {
        return "sum-row";
      }
      return "";
    },
    handleSelectionChange(selection) {
      this.selection = selection;
      let ids = this.selection.map((s) => s.id);
      let data = this.$refs.table.data.filter((item) => ids.includes(item.id));
      this.selectedData = data;
      //상단에 전기미결금 수정
      if (this.selectedData[0].type_flag === "3") {
        if (this.selectedData.length === 1) {
          this.selectedData[0].balance = this.last_item
            ? this.last_item.balance
            : 0;
        } else {
          this.selectedData[0].balance =
            this.selectedData[1].balance +
            this.selectedData[1].expense -
            this.selectedData[1].income;
        }
      }
    },
    handleClickListPrint() {
      this.dialog_visible = true;
    },
    handleCompletedListPrint(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleClickExcel() {
      this.$refs.table.downloadExcel();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/_variables.scss";

.ExpenseLedger {
  .balance {
    color: $color-primary !important;
  }
  .el-table__row.pay-row {
    .product_name,
    .unit_name,
    .suppoy_price,
    .price {
      color: $color-danger;
    }
  }
  .el-table__row.sum-row {
    background: lightgray;
  }
  .el-table__row.warning-row {
    height: 30px;
  }
}
</style>
